"use client";

import React from "react";

import { type ISchoolClusterListItem } from "../../map-panel-context";

import { ClusterSelectionList } from "./cluster-selection/cluster-selection-list";
import { SchoolClusterSchoolTypeBadges } from "./school-cluster-school-type-badges";
import { SCHOOL_CLUSTER_PANEL_DICTIONARY } from "./school-cluster-summary.constants";

interface SchoolClusterSchoolsListProps {
  schools: ISchoolClusterListItem[];
  onSchoolSelect: (schoolId: string) => void;
}

const SchoolClusterSchoolsListComponent: React.FC<SchoolClusterSchoolsListProps> = ({
  schools,
  onSchoolSelect,
}) => {
  return (
    <ClusterSelectionList
      items={schools.map((school) => ({
        id: school.schoolId,
        name: school.schoolName,
      }))}
      renderTrailing={(item) => {
        const school = schools.find((s) => s.schoolId === item.id);
        if (!school) return null;
        return <SchoolClusterSchoolTypeBadges schoolTypes={school.schoolTypes} />;
      }}
      sectionTitle={SCHOOL_CLUSTER_PANEL_DICTIONARY.schoolsByLevel}
      onItemSelect={onSchoolSelect}
    />
  );
};

export const SchoolClusterSchoolsList = React.memo(SchoolClusterSchoolsListComponent);
